var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.notOverdueData.length && _vm.overdueData.length ? _c('b-card', [_c('label', {
    staticClass: "custom-font d-block mb-2"
  }, [_c('b', [_vm._v("Task Summary")])]), _c('b-row', {
    staticClass: "align-items-center mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    staticClass: "w-100 custom-font",
    attrs: {
      "options": _vm.dayRangeOptions,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Filter by day range"
    },
    on: {
      "input": _vm.loadSelectedDayRange
    },
    model: {
      value: _vm.filterDayRange,
      callback: function callback($$v) {
        _vm.filterDayRange = $$v;
      },
      expression: "filterDayRange"
    }
  })], 1)], 1), _vm.loadTaskSummaryChart ? _c('div', [_c('app-echart-bar', {
    staticClass: "w-100",
    attrs: {
      "option-data": _vm.chartOption
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "text-center py-3"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading..."
    }
  })], 1)])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }